import React from 'react';
import {
  Container,
  Item,
  Inner,
  Pane,
  SubTitle,
  Title,
  Image,
  Text,
  Video,
  VideoText,
  Soundbar,
} from './styles/jumbotron';

export default function Jumbotron({
  children,
  direction = 'row',
  ...restProps
}) {
  return (
    <Item {...restProps}>
      <Inner direction={direction}>{children}</Inner>
    </Item>
  );
}

Jumbotron.Container = function JumbotronContainer({ children, ...restProps }) {
  return <Container {...restProps}>{children}</Container>;
};

Jumbotron.Pane = function JumbotronPane({ children, ...restProps }) {
  return <Pane {...restProps}>{children}</Pane>;
};

Jumbotron.Title = function JumbotronTitle({ children, ...restProps }) {
  return <Title {...restProps}>{children}</Title>;
};

Jumbotron.Text = function JumbotronText({ children, ...restProps }) {
  return <Text {...restProps}>{children}</Text>;
};

Jumbotron.SubTitle = function JumbotronSubTitle({ children, ...restProps }) {
  return <SubTitle {...restProps}>{children}</SubTitle>;
};

Jumbotron.Video = function JumbotronVideo({ children, ...restProps }) {
  return <Video {...restProps}>{children}</Video>;
};

Jumbotron.VideoText = function JumbotronVideoText({ children, ...restProps }) {
  return <VideoText {...restProps}>{children}</VideoText>;
};

Jumbotron.Image = function JumbotronImage({ ...restProps }) {
  return <Image {...restProps} />;
};

Jumbotron.Soundbar = function Soundbar({ children, ...restProps }) {
  return <Soundbar {...restProps}>{children}</Soundbar>;
};
